import React, { FC, RefObject, useCallback, useEffect, useState } from 'react'
import styles from './PercentInput.module.scss'
import KeyboardInput from '../../../../components/_keyboard/_KeyboardInput'
import { useKeyboard } from '../../../../components/_keyboard/KeyboardContext';
import { getCombinationOfNotes } from '../../../../cross-cutting/SugestionNotesMoney';
import { Button } from '@mui/material';
import { floatMaskNumber, moneyMaskNumber, textToFloat } from '../../../../services/utils/Money';

export interface IPercentInputProps {
    //propertys
    onChange?: (value: number) => void,
    defaultValue?: number;
    maxValue?: number
    label?: string
    sugestion?: boolean
    onFocus?: (inputRef: RefObject<HTMLInputElement>) => void
    labelStyle?: React.CSSProperties
}

const PercentInput: FC<IPercentInputProps> = ({ onChange, maxValue, defaultValue, label, onFocus, sugestion, labelStyle }) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const { configureKeyboard } = useKeyboard();
    const [combinations, setCombinations] = useState<number[]>();
    const [currentKey, setCurrentKey] = useState("");

    useEffect(() => {
        if (defaultValue) {
            if (inputRef.current) {
                inputRef.current.value = floatMaskNumber(defaultValue);
                // inputRef.current.setSelectionRange(0, inputRef.current.value.length);
                const combination = getCombinationOfNotes(defaultValue);
                setCombinations(combination);
            }
        }
    }, [defaultValue]);

    const deleteLastDigit = useCallback((value: string) => {
        if (inputRef.current?.value) {
            let numericValue = value.replace(",", "").replace("%", "");
    
            if (numericValue.length <= 1) {
                return "0,00%";
            }
            
            numericValue = numericValue.slice(0, -1);
            
            while (numericValue.length < 3) {
                numericValue = "0" + numericValue;
            }
            
            const formattedValue = numericValue.slice(0, -2) + "." + numericValue.slice(-2);
            
            inputRef.current.value = floatMaskNumber(Number(formattedValue));
            onChange?.(Number(formattedValue));
        }
    }, [onChange])

    const onChangeHandle = useCallback((value: string) => {
        if (inputRef.current) {
            if (currentKey === 'Backspace') {
                return deleteLastDigit(value);
            }

            const _moneyValue = textToFloat(value);
            let _value = maxValue !== undefined && maxValue !== null && _moneyValue > maxValue ? maxValue : _moneyValue;
            inputRef.current.value = floatMaskNumber(_value);
            onChange?.(_value);
        }
    }, [currentKey, deleteLastDigit, maxValue, onChange]);

    const onSubmit = useCallback(() => {
        inputRef.current?.blur();
    }, []);

    const onClickChangeSugestion = useCallback((_value: number) => {
        onChangeHandle(moneyMaskNumber(_value))
    }, [onChangeHandle]);

    const onFocusHandle = useCallback((inputRef: RefObject<HTMLInputElement>) => {
        onFocus?.(inputRef)
        configureKeyboard({
            inputRef: inputRef,
            type: 'numeric',
            onChange: onChangeHandle,
            onSubmit: onSubmit,
        })
    }, [onFocus, configureKeyboard, onChangeHandle, onSubmit]);

    return (
        <>
            {sugestion &&
                <div className={styles.sugestionChange}>
                    {maxValue && <Button variant='text' className={styles.sugestionItem} onClick={() => onClickChangeSugestion(maxValue)}>{moneyMaskNumber(defaultValue ?? 0)}</Button>}
                    {combinations?.map(item => <Button key={item} variant='text' className={styles.sugestionItem} onClick={() => onClickChangeSugestion(item)}>{moneyMaskNumber(item)}</Button>)}
                </div>
            }
            <KeyboardInput
                onFocus={() => onFocusHandle?.(inputRef)}
                onChange={onChangeHandle}
                onSubmit={onSubmit}
                inputMode='numeric'
                inputRef={inputRef}
                label={label}
                labelStyle={labelStyle}
                value={floatMaskNumber(defaultValue ?? 0)}
                setCurrentKey={setCurrentKey}
            />
        </>
    )
}

export default PercentInput;
